// src/app/services/preferencias.service.ts
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class PreferenciasService {
  private readonly THEME_KEY = 'theme';
  constructor(private cookies: CookieService) {}

  guardarTema(tema: 'light'|'dark') {
    this.cookies.set(this.THEME_KEY, tema, 30, '/');
  }

  obtenerTema(): 'light'|'dark' {
    return (this.cookies.get(this.THEME_KEY) as 'light'|'dark') || 'light';
  }
}
